import React, { useState, useEffect } from 'react';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Button, Table, Checkbox, Modal } from '@whalecloud/fdx';
import CommonModal from '@/components/CommonModal';
import { getNewOfferTree } from './utils';
import styles from './index.module.less';

const AddOfferGroup = props => {
  const { title, offerGroupArr, selectedTree = [], onSubmit } = props;
  const [visible, setVisible] = useState(false);
  const [selectedInfo, setselectedInfo] = useState({});

  useEffect(() => {
    if (!isEmpty(selectedTree)) {
      const defaultInfo = {};
      selectedTree.forEach(it => {
        if (!isEmpty(it.children)) {
          defaultInfo[it.offerGroupCode] = it.children;
        }
      });
      setselectedInfo(defaultInfo);
    }
  }, [selectedTree]);

  const handleSubmit = () => {
    const { isExceeded, addOfferInfo } = getNewOfferTree(selectedInfo, offerGroupArr);
    if (!isExceeded) {
      onSubmit(addOfferInfo);
      setVisible(false);
    } else {
      Modal.warning({
        title: i18n('UPPER_LIMIT_WARING'),
      });
    }
  };

  const handleTableSelected = (e, offerGroupCode, record) => {
    const isChecked = e.target.checked;
    let curOfferList = selectedInfo[offerGroupCode] || [];
    if (isChecked) {
      curOfferList.push(record);
    } else {
      curOfferList = curOfferList.filter(it => it.offerId !== record.offerId);
    }
    selectedInfo[offerGroupCode] = curOfferList;
  };

  const isChecked = (offerGroupCode, offer) => {
    const { offerId, duplicateFlag } = offer;
    // selectedTree // 【offerGroupMemDtoList[0].duplicateFlag】非 A 或者 非空，才可以重复订购
    if (!duplicateFlag || duplicateFlag === 'A') {
      const offerGroup = selectedTree.find(it => it.offerGroupCode === offerGroupCode);
      if (!offerGroup) {
        return false;
      }
      const { children } = offerGroup;
      const hasOfferInfo = children.some(it => it.offerId === offerId);
      return hasOfferInfo;
    }
    return false;
  };

  const tabeColumns = [
    {
      title: 'Offer Group Name',
      dataIndex: 'offerGroupName',
      render: (text, record) => {
        const { lowLimit, upperLimit } = record;
        return `${text} [${lowLimit || 0} - ${upperLimit || 'N'}]`;
      },
    },
    {
      title: 'Price',
      dataIndex: 'pricePrecision',
    },
  ];

  const expandedRowRender = record => {
    const { offerGroupMemDtoList, offerGroupCode } = record;
    const result = offerGroupMemDtoList.map(it => ({
      ...it,
      offerName: it.offerDto.offerName,
    }));
    const expandedTableColumns = [
      {
        title: 'Offer Group Name',
        dataIndex: 'offerName',
        render: (text, offer) => (
          <Checkbox
            defaultChecked={isChecked(offerGroupCode, offer)}
            disabled={`${get(offer, 'necessary')}` === '1'}
            onChange={e => handleTableSelected(e, offerGroupCode, offer)}
          >
            {text}
          </Checkbox>
        ),
      },
      {
        title: 'Price',
        dataIndex: 'pricePrecision',
      },
    ];

    return (
      <Table
        rowKey="offerId"
        showHeader={false}
        pagination={false}
        columns={expandedTableColumns}
        dataSource={result || []}
      />
    );
  };

  return (
    <div className={styles.addOfferGroup}>
      <Button type="primary" size="small" icon="plus" onClick={() => setVisible(true)}>{i18n('BUTTON_ADD')}</Button>
      {
        visible && (
          <CommonModal
            modalOpts={{
              title,
              footer: [
                <Button type="primary" onClick={handleSubmit} key="COMMON_OK">{i18n('COMMON_OK')}</Button>,
                <Button onClick={() => setVisible(false)} key="COMMON_CANCEL">{i18n('COMMON_CANCEL')}</Button>,
              ],
              draggable: false,
              onCancel: () => setVisible(false),
              width: 800,
              className: styles.offerGroupModal,
            }}
          >
            <Table
              rowKey="offerGroupCode"
              pagination={false}
              defaultExpandAllRows
              columns={tabeColumns}
              dataSource={offerGroupArr || []}
              expandedRowRender={(record, i) => expandedRowRender(record, i)}
            />
          </CommonModal>
        )
      }
    </div>
  );
};

export default AddOfferGroup;
